import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GdkAlertService {


  constructor(private  translate: TranslateService) {

  }

  stransToString(val: string): string {
    this.translate.get(val).subscribe(s => {
      val = s;
    });
    return val;
  }

  success(message: string) {

    alert(message);


  }

  error(message: string) {
    alert(message);


  }

  warning(msg: string) {
    alert(msg);


  }

  confirm(message: string, title?: string, okCallback?: () => void): void {
    if (okCallback) {
      alert(message);
    }


  }

  alert(msg: string, title?: string, callBack?: () => void): void {
    if (callBack) {
      alert(msg); callBack();


    }

  }

  notify(msg: string, typeAlert: 'success' | 'error' | 'warning', wait: number = 2, callBack?: () => void): void {
    alert(msg);

  }

  public loading(show: boolean = false, optionshow: Number = 1) {
    const el_loading = document.getElementById('v-loading');
    if (show) {
      if (el_loading != null) {
        el_loading.setAttribute('style', 'display:block');
      } else {
        const div_v_loading = document.createElement('div');
        div_v_loading.id = 'v-loading';
        div_v_loading.className = 'backdrop full-screen';
        switch (optionshow) {
          case 1: {
            div_v_loading.innerHTML = `
                           <div>
                              <div class="spinner-three-bounce">
                                  <div class="bounce1" style="background-color: rgb(221, 41, 41);"></div>
                                  <div class="bounce2" style="background-color: rgb(255, 139, 139);"></div>
                                  <div class="bounce3" style="background-color: rgb(255, 255, 255);"></div>
                              </div>
                            </div>`;
            break;
          }
          case 2: {
            div_v_loading.innerHTML = ` <div>
                                                          <div class="spinner-rectangle-bounce">
                                                              <div class="rect1"></div>
                                                              <div class="rect2"></div>
                                                              <div class="rect3"></div>
                                                              <div class="rect4"></div>
                                                              <div class="rect5"></div>
                                                          </div>
                                                      </div>`;
            break;
          }
          case 3: {
            div_v_loading.innerHTML = `<div>
              <div class="spinner-circle-swish"></div>
          </div>`;
            break;
          }
          case 4: {
            div_v_loading.innerHTML = ` <div>
                                                      <div class="spinner-circle">
                                                          <div>
                                                              <div class="sk-cube sk-cube1"></div>
                                                              <div class="sk-cube sk-cube2"></div>
                                                              <div class="sk-cube sk-cube3"></div>
                                                              <div class="sk-cube sk-cube4"></div>
                                                              <div class="sk-cube sk-cube5"></div>
                                                              <div class="sk-cube sk-cube6"></div>
                                                              <div class="sk-cube sk-cube7"></div>
                                                              <div class="sk-cube sk-cube8"></div>
                                                              <div class="sk-cube sk-cube9"></div>
                                                          </div>
                                                      </div>
                                                  </div>`;
            break;
          }
          default: {
            div_v_loading.innerHTML = `<div>
                                                      <div class="spinner-three-bounce">
                                                          <div class="bounce1" style="background-color: rgb(255, 255, 255);"></div>
                                                          <div class="bounce2" style="background-color: rgb(255, 255, 255);"></div>
                                                          <div class="bounce3" style="background-color: rgb(255, 255, 255);"></div>
                                                      </div>
                                                    </div>`;
          }
        }
        document.body.appendChild(div_v_loading);
      }

    } else {
      if (el_loading != null) {
        setTimeout(e => {
          el_loading.setAttribute('style', 'display:none');
        }, 0);
      }
    }
  }
}
